import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type DialogProps } from 'base-ui'

import { ExperimentOdsVideoConsultationWrapper } from '../../ods/components/ExperimentOdsVideoConsultationWrapper'

import { ProductPageOdsDialogContent } from './ProductPageOdsDialogContent'
import { ProductPageOdsShellDialog } from './ProductPageOdsShellDialog'

type ProductPageOdsDialogProps = Pick<DialogProps, 'onClose' | 'open'>

export const ProductPageOdsDialog: FC<ProductPageOdsDialogProps> = ({
  onClose,
  open,
}) => (
  <ProductPageOdsShellDialog
    onClose={onClose}
    open={open}
    title={
      <ExperimentOdsVideoConsultationWrapper
        childVideoConsultationV1={
          <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.title" />
        }
        childZavaProvider={
          <FormattedMessage id="pdp.buyboxwithvariants.odsModal.title" />
        }
      />
    }
  >
    <ExperimentOdsVideoConsultationWrapper
      childVideoConsultationV1={<ProductPageOdsDialogContent />}
      childZavaProvider={<ProductPageOdsDialogContent />}
    />
  </ProductPageOdsShellDialog>
)
